exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.limit-results {\n    border: 1px solid #ccc;\n    padding: 15px;\n    width: 49%;\n    display: inline-block;\n    margin-bottom: 10px;\n}\n.form-group .bootstrap-tagsinput .tag {\n    color: #333;\n}\n.form-group .tag-label {\n    display: block;\n}\n", ""]);

// exports
